import {evite} from 'evite';
import * as styledComponents from 'node-modules-styled-components';

Object.assign(exports, styledComponents);
evite.set(evite, 'exports.styledComponents', exports);
window.styledComponents = styledComponents;
